var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconionicMdSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-search",
    "data-name": "Icon ionic-md-search",
    d: "M22.307,20.214H21.167l-.428-.357a9.456,9.456,0,0,0,2.208-6.071,9.224,9.224,0,1,0-9.188,9.286,9.546,9.546,0,0,0,6.054-2.214l.427.357v1.143L27.363,29.5,29.5,27.357Zm-8.547,0a6.429,6.429,0,1,1,6.41-6.429A6.393,6.393,0,0,1,13.759,20.214Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#0267c1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicMdSearch);
export default __webpack_public_path__ + "static/media/Icon ionic-md-search.26ed309fb71909accb33e5127d423066.svg";
export { ForwardRef as ReactComponent };